// import decode from 'jwt-decode';

import auth0 from 'auth0-js';
import jwt_decode from "jwt-decode";
import { NavigationGuard } from 'vue-router';
// import Auth0Lock from 'auth0-lock';
const ID_TOKEN_KEY = 'covid_19_id_token';
const ACCESS_TOKEN_KEY = 'covid_19_access_token';

const CLIENT_ID = process.env.VUE_APP_AUTH0_CLIENT_ID;
const CLIENT_DOMAIN = process.env.VUE_APP_AUTH0_DOMAIN;
const REDIRECT = process.env.VUE_APP_AUTH0_CALLBACK_URL;
const SCOPE = 'openid';

const auth = new auth0.WebAuth({
  clientID: CLIENT_ID,
  domain: CLIENT_DOMAIN,
});

export function login() {
  auth.authorize({
    responseType: 'token id_token',
    redirectUri: REDIRECT,
    scope: SCOPE,
  });
}


function clearIdToken() {
  localStorage.removeItem(ID_TOKEN_KEY);
}

function clearAccessToken() {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
}

export function logout() {
  clearIdToken();
  clearAccessToken();
}

export function getIdToken() {
  return localStorage.getItem(ID_TOKEN_KEY);
}

export function getAccessToken() {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
}

// Helper function that will allow us to extract the access_token and id_token
function getParameterByName(name: string): string {
  const match = RegExp('[#&]' + name + '=([^&]*)').exec(window.location.hash);
  return (match && decodeURIComponent(match[1].replace(/\+/g, ' '))) || '';
}

// Get and store access_token in local storage
export function setAccessToken() {
  const accessToken = getParameterByName('access_token');
  localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
}

// Get and store id_token in local storage
export function setIdToken() {
  const idToken = getParameterByName('id_token');
  localStorage.setItem(ID_TOKEN_KEY, idToken);
}

interface TokenWithExpiry {
  exp?: number;
}

function getTokenExpirationDate(encodedToken: string): Date | null {
  const token = jwt_decode<TokenWithExpiry>(encodedToken);
  if (!token.exp) {
    return null;
  }

  const date = new Date(0);
  date.setUTCSeconds(token.exp);

  return date;
}

function isTokenExpired(token: string | null) {
  if (token == null) {
    return true;
  } 
  const expirationDate = getTokenExpirationDate(token);
  if (expirationDate == null) {
    return true;
  }
  return expirationDate < new Date();
}

export function isLoggedIn() {
  const idToken = getIdToken();
  return Boolean(idToken) && !isTokenExpired(idToken);
}

export const requireAuth: NavigationGuard = (to, from, next) => {
  if (!isLoggedIn()) {
    next({
      path: '/',
      query: { redirect: to.fullPath },
    });
  } else {
    next();
  }
};

